const Header = () => {
    return (
        <div>
            <h1>Weather App</h1>
        </div>
    )
}

export default Header
